import { useMutation } from '@tanstack/react-query';

import { apiRequest } from '../api/client';
import { useSessionStore } from './session-store';

export interface LoginCredentials {
  email: string;
  password: string;
  totpCode?: string;
}

interface LoginResponse {
  userId: string;
  accessToken: string;
  accessTokenExpiresAt: string;
  mustEnrollTotp: boolean;
}

/**
 * The refresh token is never named here. It arrives as an httpOnly cookie the
 * browser stores by itself, which is the point: there is nothing for this code
 * to hold, and so nothing for a script on the page to steal.
 */
export function useLogin() {
  const signIn = useSessionStore((state) => state.signIn);

  return useMutation({
    mutationFn: async (credentials: LoginCredentials) =>
      apiRequest<LoginResponse>('/auth/login', {
        method: 'POST',
        body: JSON.stringify(credentials),
      }),
    onSuccess: (response) => {
      signIn({
        userId: response.userId,
        accessToken: response.accessToken,
        accessTokenExpiresAt: new Date(response.accessTokenExpiresAt),
        mustEnrollTotp: response.mustEnrollTotp,
      });
    },
  });
}
